
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke-width":"1.2","d":"M11.87 11.59v6.82a.86.86 0 001.33.71l5.11-3.41a.85.85 0 000-1.42l-5.11-3.41a.86.86 0 00-1.33.71z"}}),_c('rect',{attrs:{"stroke-width":"1.6","x":"3.13","y":"5.94","width":"23.75","height":"18.13","rx":"4.68","ry":"4.68"}})])])
          )
        }
      }
    